import { required } from '../helpers'
import { ValidationFunctions } from '../types'

export const text: ValidationFunctions = {
  _self: {
    required,
    regExp: (expression: string) => (value: string) => RegExp(expression).test(value),
    minLength: (minLength: number) => (value: string) => value.length >= minLength,
    maxLength: (maxLength: number) => (value: string) => value.length <= maxLength,
  },
}
